import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			documentVersion: '=',
		},
		controller: /* @ngInject */ ($scope, DocumentsVersions, DocumentsService) => {
			$scope.googlePreviewMaximumFileSize = 10 * 1000 * 1024;

			$scope.refresh = (documentVersion) => {
				if (documentVersion) {
					$scope.classification = DocumentsService.getClassicationForMimeType(documentVersion.mimeType);

					$scope.downloadURL      = DocumentsService.getDownloadURLForDocumentVersionId(documentVersion.id);
					$scope.googlePreviewURL = DocumentsService.getGooglePreviewURLForURL($scope.downloadURL);

					$scope.vjsMedia = {
						sources: [
							{
								src:  $scope.downloadURL,
								type: documentVersion.mimeType,
							},
						],
					};
				}
			};

			$scope.$watch('documentVersion', (newValue) => {
				$scope.refresh(newValue);
			});

			$scope.refresh();
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/documentPreviewVersion/index.js